import { getEnv } from "../env";

export function getDatastoreWarName() {
	let dn = getEnv('REACT_APP_WAR_NAME') || 'XSportDatastore';
	if (dn.startsWith("/")) {
		dn = dn.substring(1);
	}
	return dn;
}
